import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/select";
import type { Option, RowState } from "@/components/advanceSearch/types";

export const FieldSelect: React.FC<{
  row: RowState;
  fieldOptions: Option[];
  onChangeField: (fieldName: string) => void;
}> = ({ row, fieldOptions, onChangeField }) => (
  <div className="w-full">
    <Select value={row.fieldName} onValueChange={(value) => onChangeField(value)}>
      <SelectTrigger className="w-full justify-between rounded-md bg-white px-4 text-sm font-medium text-gray-700 shadow-none focus:ring-0">
        <SelectValue placeholder="Select field" />
      </SelectTrigger>
      <SelectContent className="w-full min-w-[unset]">
        {fieldOptions.map((f) => (
          <SelectItem key={f.value} value={f.value}>
            {f.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);
